import { library } from '@fortawesome/fontawesome-svg-core';
import { faAlarmExclamation } from '@fortawesome/pro-light-svg-icons/faAlarmExclamation';
import { faArrowAltToBottom } from '@fortawesome/pro-light-svg-icons/faArrowAltToBottom';
import { faArrowAltToTop } from '@fortawesome/pro-light-svg-icons/faArrowAltToTop';
import { faArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowDown';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import { faArrowsRotate } from '@fortawesome/pro-light-svg-icons/faArrowsRotate';
import { faArrowUpRight } from '@fortawesome/pro-light-svg-icons/faArrowUpRight';
import { faBadgeDollar } from '@fortawesome/pro-light-svg-icons/faBadgeDollar';
import { faBell } from '@fortawesome/pro-light-svg-icons/faBell';
import { faBox } from '@fortawesome/pro-light-svg-icons/faBox';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons/faCalendarAlt';
import { faCalendarCheck } from '@fortawesome/pro-light-svg-icons/faCalendarCheck';
import { faCalendarDay } from '@fortawesome/pro-light-svg-icons/faCalendarDay';
import { faCalendarPlus } from '@fortawesome/pro-light-svg-icons/faCalendarPlus';
import { faCalendarTimes } from '@fortawesome/pro-light-svg-icons/faCalendarTimes';
import { faCalendarXmark } from '@fortawesome/pro-light-svg-icons/faCalendarXmark';
import { faCamera } from '@fortawesome/pro-light-svg-icons/faCamera';
import { faChartLine } from '@fortawesome/pro-light-svg-icons/faChartLine';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faCircle } from '@fortawesome/pro-light-svg-icons/faCircle';
import { faCircleDollar } from '@fortawesome/pro-light-svg-icons/faCircleDollar';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons/faCircleQuestion';
import { faCircleXmark } from '@fortawesome/pro-light-svg-icons/faCircleXmark';
import { faClapperboardPlay } from '@fortawesome/pro-light-svg-icons/faClapperboardPlay';
import { faCommentAlt } from '@fortawesome/pro-light-svg-icons/faCommentAlt';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faDownToLine } from '@fortawesome/pro-light-svg-icons/faDownToLine';
import { faEdit } from '@fortawesome/pro-light-svg-icons/faEdit';
import { faEllipsisVertical } from '@fortawesome/pro-light-svg-icons/faEllipsisVertical';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { faExternalLink } from '@fortawesome/pro-light-svg-icons/faExternalLink';
import { faExternalLinkSquareAlt } from '@fortawesome/pro-light-svg-icons/faExternalLinkSquareAlt';
import { faFileAlt } from '@fortawesome/pro-light-svg-icons/faFileAlt';
import { faFileLines } from '@fortawesome/pro-light-svg-icons/faFileLines';
import { faFlag } from '@fortawesome/pro-light-svg-icons/faFlag';
import { faFolder } from '@fortawesome/pro-light-svg-icons/faFolder';
import { faFolders } from '@fortawesome/pro-light-svg-icons/faFolders';
import { faGripLines } from '@fortawesome/pro-light-svg-icons/faGripLines';
import { faImage } from '@fortawesome/pro-light-svg-icons/faImage';
import { faLightbulb } from '@fortawesome/pro-light-svg-icons/faLightbulb';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { faMessage } from '@fortawesome/pro-light-svg-icons/faMessage';
import { faMessageQuestion } from '@fortawesome/pro-light-svg-icons/faMessageQuestion';
import { faMicrochipAi } from '@fortawesome/pro-light-svg-icons/faMicrochipAi';
import { faPage } from '@fortawesome/pro-light-svg-icons/faPage';
import { faPause } from '@fortawesome/pro-light-svg-icons/faPause';
import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faPhoneLaptop } from '@fortawesome/pro-light-svg-icons/faPhoneLaptop';
import { faPlay } from '@fortawesome/pro-light-svg-icons/faPlay';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faQuestion } from '@fortawesome/pro-light-svg-icons/faQuestion';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faSignalStream } from '@fortawesome/pro-light-svg-icons/faSignalStream';
import { faSpinner } from '@fortawesome/pro-light-svg-icons/faSpinner';
import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons/faSpinnerThird';
import { faSquareQuestion } from '@fortawesome/pro-light-svg-icons/faSquareQuestion';
import { faStar } from '@fortawesome/pro-light-svg-icons/faStar';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faUpload } from '@fortawesome/pro-light-svg-icons/faUpload';
import { faUpToLine } from '@fortawesome/pro-light-svg-icons/faUpToLine';
import { faWallet } from '@fortawesome/pro-light-svg-icons/faWallet';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

library.add(
  faAlarmExclamation,
  faArrowAltToBottom,
  faArrowAltToTop,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faArrowUpRight,
  faBadgeDollar,
  faBell,
  faBox,
  faCalendarAlt,
  faCalendarDay,
  faCalendarPlus,
  faCalendarTimes,
  faCamera,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCircleDollar,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faCommentAlt,
  faCopy,
  faDownToLine,
  faEdit,
  faEllipsisVertical,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLink,
  faExternalLinkSquareAlt,
  faFileAlt,
  faFileLines,
  faFlag,
  faFolder,
  faFolders,
  faGripLines,
  faImage,
  faLightbulb,
  faLock,
  faMessage,
  faMessageQuestion,
  faMicrochipAi,
  faPage,
  faPause,
  faPencil,
  faPhoneLaptop,
  faPlay,
  faPlus,
  faQuestion,
  faSearch,
  faShieldCheck,
  faSignalStream,
  faSpinner,
  faSpinnerThird,
  faSquareQuestion,
  faStar,
  faTrash,
  faUpload,
  faUpToLine,
  faWallet,
  faXmark,
  faCalendarCheck,
  faCalendarXmark,
  faClapperboardPlay,
  faChevronRight
);
